import React from "react";
import notAvalaible from "../../assets/svg/notAvalaible.svg";
import "../../styles/common/emptyPage.scss";

const EmptyPage = ({ content }) => {
  return (
    <div>
      <>
        <div className="empty-data-container">
          <img
            src={notAvalaible}
            alt="No courses available"
            className="empty-data-img"
          />
          <p className="">{content || "No available"}</p>
        </div>
      </>
    </div>
  );
};

export default EmptyPage;
